import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";

export const acceptPrivacyPolicies = async (
  cartTag: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.put(
    M3_API().ACCEPT_PRIVACY_POLICIES,
    {},
    {
      params: { cartTag },
      headers: {
        Prefer: "code=200, example=default",
      },
    }
  );
};

/**
 * To get the Privacy Policy document HTML
 * @param locale string
 * @param cartTag string (optional) - used for Brazil subscription model detection
 * @returns document HTML
 */
export const getPrivacyPolicy = async (
  locale: string,
  cartTag?: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.get(M3_API().PRIVACY_POLICY, {
    params: {
      locale,
      ...(cartTag && { cartTag }),
    },
    headers: {
      Prefer: "code=200, example=Get Privacy Document",
    },
  });
};
